<template>
  <div class="qsSearchWrap" id="searchLayoutWrap" :class="{ searchPaddingBottom: bottomDistance }"
    :style="{ background: backgroundColor }" v-loading="loading">
    <!-- 搜索框区域 -->
    <div class="searchLayoutTopWrap" :style="{ maxHeight: getMaxHeight }">
      <div :class="[{ searchLayoutTop: layoutControl }, 'qsSearchTop_' + times]">
        <slot></slot>
        <!-- 按钮区域紧跟在内容后方区域-->
        <div v-if="$slots.moreBtn && (!showBtn && !forceNewLine)" class="searchLayoutAside">
          <slot name="moreBtn"></slot>
        </div>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div v-if="$slots.moreBtn && (showBtn || forceNewLine)"
      :class="['searchOutBtnBox', { 'hasSearchLayoutBtn': showBtn }]">
      <!-- <el-form-item label=" " class="searchLayoutPlaceholder"> </el-form-item> -->
      <slot name="moreBtn"></slot>
    </div>

    <!-- 更多查询按钮 -->
    <el-button class="searchLayoutBtn" type="text" @click="searchMoreClick()" v-if="showBtn">
      <a> {{ showAll ? "收起查询" : "更多查询" }} </a>
      <i :class="showAll ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
    </el-button>
  </div>
</template>

<script>
/**
 * maxLine：默认最大展开行数
 * layoutControl：默认控制样式布局（横向flex及换行布局）
 * baseHeight：基准行高度，默认48
 * bottomDistance：增加底部距离16px,默认无此距离
 */
import { debounce } from '../utils'

const MODE = {
  GROUP: 'group',
  SINGLE: 'single',
}
export default {
  name: 'QSSearch',
  provide() {
    return {
      blmSearchInstance: this,
    }
  },
  props: {
    maxLine: {
      type: [Number, String],
      default: 4,
    },
    forceNewLine: {
      type: Boolean,
      default: true,
    },
    layoutControl: {
      type: Boolean,
      default: true,
    },
    baseHeight: {
      type: Number,
      default: 48, // 32height+16pading，基准每行高度
    },
    bottomDistance: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '#f7f8fa',
    },
    /**
     * 展示模式：分组group｜单独的single
     */
    mode: {
      type: String,
      default: MODE.SINGLE,
    },
    /**
     * 分组模式下，默认初始展示的分组个数
     */
    showGroupNumber: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      showAll: false, // 是否展示全部区域
      maxHeight: this.maxLine * this.baseHeight, // 收起状态最大高度
      calcLine: 0, // 内容总共行数
      times: -1,
      loading: true,
      calcLayout: () => ({}),
    }
  },
  computed: {
    isGroup() {
      return this.mode === MODE.GROUP
    },
    showBtn() {
      return !!(this.calcLine > this.maxLine || this.isGroup)
    },
    getMaxHeight() {
      if (this.isGroup) {
        return 'none'
      }
      return !this.showAll ? `${this.maxHeight}px` : 'none'
    },
  },
  created() {
    let times = sessionStorage.getItem('blmSearchTimes') || -1
    ++times
    this.times = times
    sessionStorage.setItem('blmSearchTimes', times)
    this.calcLayout = debounce(this.calcLayout1)
  },
  mounted() {
    this.$nextTick(() => {
      // 计算
      this.calcLayout()
      this.calcGroupItemStyle()
      // 监听帮助中心收起和展开
      const box = document.querySelector('.app-main')
      if (!box) {
        console.error('未在.app-main内使用！请检查～')
        return
      }
      const MutationObserver = window.MutationObserver || window.webkitMutationObserver || window.MozMutationObserver
      this.mutationObserver = new MutationObserver(() => {
        const width = this.getDom()?.offsetWidth
        if (width === this.totalWidth) {
          return
        }
        this.totalWidth = width
        this.calcLayout()
      })
      this.mutationObserver.observe(box, {
        attributes: true,
        attributeFilter: ['is-help-center', 'sidebar-status'],
        attributeOldValue: true,
      })
    })
    this.listenEnterKey()
    // 监听窗口变化
    window.addEventListener('resize', this.calcLayout)
  },
  destroyed() {
    this.removeListenEnterKey()
    window.removeEventListener('resize', this.calcLayout)
    if (this.mutationObserver) {
      this.mutationObserver.disconnect()
      this.mutationObserver.takeRecords()
      this.mutationObserver = null
    }
  },
  // 解决动态高度问题
  updated() {
    this.calcLayout()
  },
  methods: {
    // 需要监听的元素
    returnEle() {
      const handleNodeList = []
      document.querySelectorAll('.searchLayoutTopWrap').forEach((node) => {
        if (node.querySelectorAll('.el-date-editor').length > 0) handleNodeList.push(node.querySelectorAll('.el-date-editor'))
        if (node.querySelectorAll('.el-cascader').length > 0) handleNodeList.push(node.querySelectorAll('.el-cascader'))
      })
      return {
        handleNodeList,
      }
    },
    listenFun(e) {
      if (e.key === 'Enter') {
        e.preventDefault()
      }
    },
    // 监听筛选框回车键
    listenEnterKey() {
      // 监听 日期选择器选择器 回车事件
      // 监听 级联选择器 回车事件
      const { handleNodeList } = this.returnEle()
      if (handleNodeList.length > 0) {
        handleNodeList.forEach((nodeList) => {
          nodeList.forEach((node) => {
            node.addEventListener('keydown', this.listenFun)
          })
        })
      }
    },
    // 移除监听
    removeListenEnterKey() {
      const { handleNodeList } = this.returnEle()
      if (handleNodeList.length > 0) {
        handleNodeList.forEach((nodeList) => {
          nodeList.forEach((node) => {
            node.removeEventListener('keydown', this.listenFun)
          })
        })
      }
    },
    searchMoreClick(outControl) {
      if (outControl && this.showBtn) {
        // 外部需主动控制打开场景。未展开状态下可操作展开，已展开状态下不可操作展开。
        return
      }
      this.showAll = !this.showAll
      this.calcGroupItemStyle()
    },
    calcLayout1() {
      if (this.isGroup) {
        this.loading = false
        return
      }
      const selectBox = this.getDom()
      const totalHeight = selectBox?.offsetHeight || 0
      this.calcLine = Math.floor(totalHeight / this.baseHeight)
      this.maxHeight = this.maxLine * this.baseHeight
      this.loading = false
    },
    getDom() {
      const className = `qsSearchTop_${this.times}`
      const dom = document.getElementsByClassName(className)[0]
      return dom
    },
    calcGroupItemStyle() {
      if (this.isGroup) {
        const itemList = document.querySelectorAll('.components-page__QSSearchGroupItem')
        if (!itemList.length) {
          return
        }
        itemList.forEach((item, index) => {
          if (this.showGroupNumber <= index) {
            itemList[index].style.height = this.showAll ? 'auto' : '0'
          }
        })
      }
    },
  },
}
</script>

<style lang='scss'>
#searchLayoutWrap {
  .double-data-entry {

    .el-input,
    .el-input-number {
      width: 106px;
    }

    .a-input {
      width: 106px;
    }
  }

  .el-form-item:not(.double-data-entry) {
    .el-form-item__content {
      // width: 226px;
      .el-select, .el-input, .el-cascader, .qs-biz-city__wrap, .qs-biz-car-team__wrap, .qs-biz-fleet__wrap{
        // width: 100%;
        width: 226px;
      }
    }
  }

  .el-form-item {
    .el-form-item__label {
      padding-right: 0;
      margin-right: 10px;
    }
  }
}
</style>

<style scoped lang='scss'>
#searchLayoutWrap {
  position: relative;
  background: #f7f8fa;
  padding: 16px 16px 0;

  .searchLayoutTopWrap {
    overflow: hidden;
  }

  .searchLayoutTop {
    display: flex;
    flex-wrap: wrap;

    // * {
    //   display: inherit;
    // }
  }

  ::v-deep .el-form-item {
    display: inline-flex;
    flex-wrap: nowrap;
    margin-right: 16px;
  }

  .searchLayoutPlaceholder {
    margin-right: 0;
  }

  .searchLayoutBtn {
    position: absolute;
    right: 16px;
    bottom: 16px;
  }

  &.searchPaddingBottom {
    padding: 16px;
  }

  .searchOutBtnBox {
    display: flex;
    margin: 0 0 0 110px;
    // ::v-deep .el-form-item .el-form-item__content {
    //   width: auto;
    // }


    &.hasSearchLayoutBtn {
      margin: 0 99px 0 110px;
      flex-wrap: wrap;
    }
  }
  // .searchLayoutAside {
  //   ::v-deep .el-form-item .el-form-item__content {
  //     width: auto;
  //   }
  // }
}
</style>
